"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = deleteItem;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _ = require(".");

var _utils = require("./utils");

function deleteItem(_x) {
  return _deleteItem.apply(this, arguments);
}

function _deleteItem() {
  _deleteItem = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref) {
    var client, path, id;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            client = _ref.client, path = _ref.path, id = _ref.id;
            (0, _utils.checkValidId)(id);
            _context.prev = 2;
            _context.next = 5;
            return client.delete(path + ("/" + id), {
              headers: {
                Accept: _.APPLICATION_JSON
              }
            });

          case 5:
            _context.next = 10;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](2);
            throw new Error("Failed to delete item with id: " + id + " and path: " + path);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 7]]);
  }));
  return _deleteItem.apply(this, arguments);
}